import LogoSPMB from "@/assets/logos/logo_spmb_undiksha.png"
import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { formatDateIndonesia } from "@/lib/utils"
import { DataPendaftaran, RuangCbtDetail } from "@/types"
import { FaFilePdf } from "react-icons/fa6"
import { HiOutlineArrowNarrowLeft } from "react-icons/hi"
import { useQuery } from "@tanstack/react-query"
import { Link, useSearchParams } from "react-router-dom"

export default function AlbumPesertaPage() {
  const [searchParams] = useSearchParams()
  const idRefRuangCbtParams = searchParams.get("id_ref_ruang_cbt")
  const tanggalCbtParams = searchParams.get("tanggal_cbt")
  const sesiParams = searchParams.get("sesi")

  const { data, isPending } = useQuery({
    queryFn: async () => {
      if (idRefRuangCbtParams)
        searchParams.set("id_ref_ruang_cbt", idRefRuangCbtParams)
      if (tanggalCbtParams) searchParams.set("tanggal_cbt", tanggalCbtParams)
      if (sesiParams) searchParams.set("sesi", sesiParams)

      const response = await api.get(
        `/smbjm/ruang-cbt/album-peserta?${searchParams.toString()}`
      )

      return response.data?.data
    },
    queryKey: [
      "albumPeserta",
      idRefRuangCbtParams,
      tanggalCbtParams,
      sesiParams,
    ],
    enabled: !!idRefRuangCbtParams && !!tanggalCbtParams && !!sesiParams,
    retry: false,
  })

  if (isPending) return <SkeletonTable />

  const isDaring = data?.ruangan?.ruang_cbt?.jenis_ruang == "daring"

  return (
    <div>
      <Link to={"/panitia-smbjm/ruang-cbt-detail"}>
        <div className="print:hidden rounded-full p-10 border border-dashed border-black flex justify-center items-center gap-5 hover:bg-secondary cursor-pointer font-bold text-xl">
          <HiOutlineArrowNarrowLeft size={20} /> Kembali
        </div>
      </Link>
      {data && (
        <div
          className="print:hidden mt-10 rounded-full p-10 border border-dashed border-black flex justify-center items-center gap-5 hover:bg-secondary cursor-pointer font-bold text-xl"
          onClick={() => window.print()}
        >
          <FaFilePdf size={20} /> CETAK PDF
        </div>
      )}
      {data ? (
        <>
          <section className="h-screen flex justify-center items-center">
            <div className="text-center">
              <img src={LogoSPMB} alt="SPMB" width={500} className="mx-auto" />
              <h1 className="my-10 font-bold text-2xl">
                ALBUM BUKTI HADIR PESERTA SMBJM CBT {new Date().getFullYear()}
              </h1>
              {/* <h2 className="font-bold text-4xl">PUSAT CBT</h2>
          <h2 className="font-bold text-4xl">6120</h2> */}
              <h2 className="font-extrabold text-4xl">
                UNIVERSITAS PENDIDIKAN GANESHA
              </h2>
              <br />
              <br />
              <div className="py-5 border-y border-black">
                <div className="font-bold text-2xl">
                  <span className="text-primary uppercase">
                    {data?.ruangan?.ruang_cbt?.jenis_ruang} {"  "}
                  </span>
                  <span>{data?.ruangan?.ruang_cbt?.nama_ruang}</span>
                </div>
                <div className="font-bold text-2xl">
                  <span className="text-primary">SESI {"  "}</span>
                  <span>
                    {data?.ruangan?.sesi}
                    {" / "}
                    {data?.ruangan?.tanggal_cbt &&
                      formatDateIndonesia(data?.ruangan?.tanggal_cbt)}
                  </span>
                </div>
              </div>
              <br />
              <br />

              <div className="p-5 border border-black rounded-xl">
                <table className="w-full font-bold text-xl">
                  <tbody>
                    <tr>
                      <th className="py-1.5 uppercase text-start">Lokasi</th>
                      <td className="py-1.5 px-5">:</td>
                      <td className="py-1.5 text-start">
                        {isDaring ? "Daring" : "Universitas Pendidikan Ganesha"}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-1.5 uppercase text-start">Ruangan</th>
                      <td className="py-1.5 px-5">:</td>
                      <td className="py-1.5 text-start">
                        {data?.ruangan?.ruang_cbt?.nama_ruang}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-1.5 uppercase text-start">Alamat</th>
                      <td className="py-1.5 px-5">:</td>
                      <td className="py-1.5 text-start">
                        {data?.ruangan?.ruang_cbt?.alamat_ruang}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-1.5 uppercase text-start">Kapasitas</th>
                      <td className="py-1.5 px-5">:</td>
                      <td className="py-1.5 text-start">
                        {data?.ruangan?.ruang_cbt?.kapasitas_ruang}
                      </td>
                    </tr>
                    <tr>
                      <th className="py-1.5 uppercase text-start">Sesi</th>
                      <td className="py-1.5 px-5">:</td>
                      <td className="py-1.5 text-start">
                        {data?.ruangan?.sesi}
                      </td>
                    </tr>
                    {/* <tr>
                  <th className="py-1.5 uppercase text-start">Album</th>
                  <td className="py-1.5 px-5">:</td>
                  <td className="py-1.5 text-start">1/2</td>
                </tr> */}
                    {/* <tr>
                  <th className="py-1.5 uppercase text-start">Nomor</th>
                  <td className="py-1.5 px-5">:</td>
                  <td className="py-1.5 text-start">
                    256120070201 s/d 256120070220
                  </td>
                </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
          <section className="min-h-screen">
            <table className="w-full">
              <thead>
                <tr>
                  <th colSpan={3} className="py-3">
                    <div className="flex items-center justify-center gap-5">
                      <img src={LogoSPMB} alt="SPMB" className="h-[5rem]" />

                      <div>
                        <h1 className="text-start font-bold text-sm">
                          BUKTI HADIR PESERTA CBT {new Date().getFullYear()}
                        </h1>
                        <table>
                          <tbody className="text-xs">
                            <tr>
                              <th className="text-start font-semibold">
                                LOKASI
                              </th>
                              <td className="px-3 font-semibold">:</td>
                              <td className="text-start font-semibold">
                                {isDaring
                                  ? "Daring"
                                  : "Universitas Pendidikan Ganesha"}
                              </td>
                            </tr>
                            <tr>
                              <th className="text-start font-semibold">
                                RUANGAN
                              </th>
                              <td className="px-3 font-semibold">:</td>
                              <td className="text-start font-semibold">
                                {data?.ruangan?.ruang_cbt?.nama_ruang}
                              </td>
                            </tr>
                            <tr>
                              <th className="text-start font-semibold">
                                KAPASITAS
                              </th>
                              <td className="px-3 font-semibold">:</td>
                              <td className="text-start font-semibold">
                                {data?.ruangan?.ruang_cbt?.kapasitas_ruang}
                              </td>
                            </tr>
                            <tr>
                              <th className="text-start font-semibold">SESI</th>
                              <td className="px-3 font-semibold">:</td>
                              <td className="text-start font-semibold">
                                {data?.ruangan?.sesi}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </th>
                </tr>
                <br />
              </thead>

              <tbody className="flex flex-col gap-y-1">
                {data?.peserta_ruang && data?.peserta_ruang?.length > 0
                  ? data?.peserta_ruang?.map(
                      (
                        peserta: RuangCbtDetail & {
                          data_pendaftaran: DataPendaftaran
                        },
                        index: number
                      ) => {
                        const nomor = index + 1
                        let nomorMeja = `${nomor}`
                        if (nomor < 10) nomorMeja = `0${nomorMeja}`

                        return (
                          <tr
                            key={index}
                            className="border border-black rounded-xl"
                          >
                            <td className="p-3 border-separate">
                              <div className="w-[5rem] aspect-[2/3] overflow-hidden">
                                <img
                                  src={
                                    peserta?.data_pendaftaran?.data_siswa
                                      ?.path_foto || ""
                                  }
                                  alt="profile"
                                  className="w-full h-full object-cover"
                                />
                              </div>
                            </td>
                            <td className="p-3 border-separate w-full">
                              <table>
                                <tbody>
                                  <tr>
                                    <th className="text-start">NOMOR MEJA</th>
                                    <td className="px-3">:</td>
                                    <td className="text-start">{nomorMeja}</td>
                                  </tr>
                                  <tr>
                                    <th className="text-start whitespace-nowrap">
                                      NOMOR PENDAFTARAN
                                    </th>
                                    <td className="px-3">:</td>
                                    <td className="text-start">
                                      {
                                        peserta?.data_pendaftaran
                                          ?.nomor_pendaftaran
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <th className="text-start">NAMA PESERTA</th>
                                    <td className="px-3">:</td>
                                    <td className="text-start">
                                      {
                                        peserta?.data_pendaftaran?.data_siswa
                                          ?.nama_lengkap
                                      }
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td className="w-full p-3 border-separate text-end">
                              <div className="ml-auto w-40 text-center">
                                <div className="ml-auto h-28 w-40 rounded-xl border border-dotted border-black flex justify-center items-center">
                                  <p className="uppercase text-gray-100 italic">
                                    Tanda Tangan
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )
                      }
                    )
                  : ""}
              </tbody>
            </table>
          </section>
        </>
      ) : (
        <section className="min-h-[80vh] flex justify-center items-center">
          <h1 className="text-xl font-semibold">Data masih kosong!</h1>
        </section>
      )}
    </div>
  )
}
